import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  HorizontalLine,
  TableHeaderCell,
  TakedownTable,
} from '../../pages/ThreadsDetails/Style/SingleThreat.style';
import { SectionColumn, SectionTitle } from '../ThreatTable/ThreatExpandedRow.style';
import { formatedDate } from '../../utils';

interface ExpandedTakedownStatusHistoryProps {
  takedownStatusHistory: any[] | undefined;
  takedownStatusHistoryLoading: boolean;
  findStatusNameById: (id: number) => string;
}

const ExpandedTakedownStatusHistory = ({
  takedownStatusHistory,
  takedownStatusHistoryLoading,
  findStatusNameById,
}: ExpandedTakedownStatusHistoryProps) => {
  const theme = useTheme();

  return (
    <SectionColumn>
      <SectionTitle>Takedown Status History</SectionTitle>
      <HorizontalLine sx={{ mb: 1 }} />
      {takedownStatusHistoryLoading ? (
        <Skeleton variant="rectangular" height={80} />
      ) : takedownStatusHistory && takedownStatusHistory.length > 0 ? (
        <TakedownTable>
          <TableContainer sx={{ maxHeight: 150 }}>
            <Table size="small" sx={{ border: 0 }}>
              <TableHead>
                <TableRow>
                  <TableHeaderCell>Status Name</TableHeaderCell>
                  <TableHeaderCell>Updated Date</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {takedownStatusHistory.map((item: any, index: number) => (
                  <TableRow key={index} sx={{ '&:last-child td': { border: 0 } }}>
                    <TableCell sx={{ fontSize: '12px', textTransform: 'capitalize' }}>
                      {findStatusNameById(item.status_id)}
                    </TableCell>
                    <TableCell sx={{ fontSize: '12px' }}>
                      {item.updated_at ? `${formatedDate(item.updated_at)} UTC` : '-'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TakedownTable>
      ) : (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.disabled, fontStyle: 'italic' }}>
          No takedown status history
        </Typography>
      )}
    </SectionColumn>
  );
};

export default ExpandedTakedownStatusHistory;
